import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'grid-styled';

import { Label } from '../styledSystem/Text';

class Checkbox extends Component {
    state = {
        isChecked: this.props.model[this.props.name] === 'true'
    };

    toggleCheckboxChange = ({ target }) => {
        console.log('checkbox update:' + JSON.stringify(this.props.name));
        this.setState(({ isChecked }) => ({
            isChecked: !isChecked
        }));

        console.log('checkbox set form valid');
        this.props.updateState({
            formValid: true
        });

        this.props.model[this.props.name] = !this.state.isChecked;
    };

    render() {
        const { label } = this.props;

        return (
            <Box w={1}>
                <Flex>
                    <Box w={1 / 2}>
                        <Label textStyle="labelNormal">{label}</Label>
                    </Box>
                    <Box w={1 / 2}>
                        <input
                            checked={this.state.isChecked}
                            type="checkbox"
                            onChange={this.toggleCheckboxChange}
                        />
                    </Box>
                </Flex>
            </Box>
        );
    }
}

Checkbox.propTypes = {
    label: PropTypes.string.isRequired
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/form/Checkbox.js